<script>

  import {
    mapGetters,
    mapActions
  } from "vuex";
  
  export default {
    name: "app",
    methods: {
      ...mapActions(["logout","unRegister"]),
      openSidebar: () => {        
        document.getElementById("mySidebar").style.display = "block";
      },
      closeSidebar: () => {
        var sb = document.getElementById("mySidebar");
        if(sb)
        {
          sb.style.display = "none";
        }
      }
      
    },
    data() {
      return {
        msg: ""
      };
    },
    computed: mapGetters(["user","contacts","devices","messagesinbox","selecteddevice"]),
    created: function() {
      // console.log(this.$store);
      // var sellerName = window.location.hostname.split(".")[0];
      // this.setSeller(sellerName);
  
    }
  };
</script>

<template>
  <div id="app">
  
    <nav class="w3-sidebar w3-bar-block w3-card" id="mySidebar" style="display:none">
      <div class="w3-container w3-theme-d2">
        <span @click="closeSidebar()" class="w3-button w3-display-topright w3-large">X</span>        
        <div  class="w3-padding w3-center">
          <img class="w3-circle" src="static/img/icons/favicon-16x16.png" alt="logo" style="width:60px">
        </div>        
        <div v-if="user" class="w3-padding w3-center">
          {{user.displayName}}
        </div>
      </div>
      <div @click="closeSidebar()">
        <router-link class="w3-bar-item w3-button" to="/">Home</router-link>        
        <router-link v-if="!user" class="w3-bar-item w3-button" to="/login">Login</router-link>                
        <router-link v-if="user && devices" class="w3-bar-item w3-button" to="/devices">Devices ({{Object.keys(devices).length}})</router-link>   
        <router-link v-if="user && selecteddevice" class="w3-bar-item w3-button" to="/devicecommands">Device Commands</router-link>   
        
        <router-link v-if="user && selecteddevice" class="w3-bar-item w3-button" to="/MessagesInbox">Messages</router-link>           
        <router-link v-if="user && selecteddevice" class="w3-bar-item w3-button" to="/Contacts">Contacts</router-link> 
        <a href="#"  v-if="user" class="w3-bar-item w3-button" @click="logout();$router.push('home')">Logout</a>
        <a href="#" class="w3-bar-item w3-button" @click="unRegister()">Refresh</a>
      </div>          
      
    </nav>
  
    <header class="w3-top w3-bar w3-theme" style="height:60px">
      <button class="w3-bar-item w3-button w3-xlarge w3-hover-theme" @click="openSidebar()">&#9776;</button>      
      <h3  @click="$router.push('home')" class="w3-bar-item w3-display-topmiddle">
        <span v-if="!selecteddevice">Messaging Service</span>
        <span v-if="selecteddevice">{{devices[selecteddevice].label || 'Messaging Service'}}</span>
      </h3> 
    </header>

    <div style="margin-top:60px" @click="closeSidebar()">
      <router-view></router-view>
    </div>

    <footer @click="closeSidebar()" class="w3-container footer">      
      Built on the FIBI.Works platform. For details see <a target="_blank" href="https://fibi.works">FIBI</a>
    </footer>
  </div>
</template>

<style>

   .footer{
     padding-top: 50px;
     text-align:center;
     font-size:10px;   

   }
</style>



// WEBPACK FOOTER //
// src/App.vue